module.exports = __webpack_public_path__ + "img/23.d0d7a5dd.jpg";